<div class="container-fluid">
  <div class="col-12">
    <app-header></app-header>
  </div>
</div>
<div class="container-fluid">
  <div class="col-12">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item pointer" *ngIf="userTerms ? userTerms.length > 0 :false">
        <a class="nav-link" [ngClass]="{'active':tabvis == 0}" (click)="tabvis = 0">User</a>
      </li>
      <li class="nav-item pointer" *ngIf="businessTerms ? businessTerms.length > 0 : false">
        <a class="nav-link" [ngClass]="{'active':tabvis == 1}" (click)="tabvis = 1">Business</a>
      </li>
    </ul>
  </div>
  <div class=" wizard labwiz termsNcond form_wizard overflow-hidden  margin-row px-4 min-height-agreement" *ngIf="tabvis == 0">
    <mat-tab-group [selectedIndex]="selectedIndex_user" (selectedTabChange)="selectedIndex_user = $event.index">
      <mat-tab *ngFor='let item of userTerms ; let i = index' label='{{item.titles}}  ( v{{item.document_version}} )'>
        <h3 class="term_title m-4">
          {{item.titles}} ( v{{item.document_version}} - Effective {{item.effective_date | date : 'MMM dd, yyyy'}} )
        </h3>
        <div [innerHTML]='item.description | urlPipe' class="h-300 m-4"></div>
        <mat-checkbox class="m-4" [(ngModel)]='userCheckmarks[i]'
          (change)='checkTerm($event , i, "userTerms", "selectedIndex_user")'>I agree</mat-checkbox>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class=" wizard labwiz termsNcond form_wizard overflow-hidden  margin-row px-4 min-height-agreement" *ngIf="tabvis == 1">
    <mat-tab-group [selectedIndex]="selectedIndex_business" (selectedTabChange)="selectedIndex_business = $event.index">
      <mat-tab *ngFor='let item of businessTerms ; let i = index'
        label='{{item.titles}}  ( v{{item.document_version}} )'>
        <p class="term_title m-4">
          {{item.titles}} ( v{{item.document_version}} - Effective {{item.effective_date | date : 'MMM dd, yyyy'}} )
        </p>
        <div [innerHTML]='item.description | urlPipe' class="h-300 m-4"></div>
        <mat-checkbox class="m-4" [(ngModel)]='businessCheckmarks[i]'
          (change)='checkTerm($event , i,"businessTerms", "selectedIndex_business")'>I agree</mat-checkbox>
        <p class="TermsBusinessTitle">
          As a representative of:
        </p>
        <div class="checkBoxGroup">
          <mat-checkbox class="m-4" *ngFor="let checkBox of item.businessList" [(ngModel)]='checkBox.checked'>
            {{checkBox.biz_display_name}}
          </mat-checkbox>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="col-12">
    <div class="text-right m-4">
      <button mat-button class="mr-2" (click)='backToLogin()' color='primaryStrCus'>Back to Login</button>
      <button mat-button class="mr-2" (click)='back()' *ngIf='hasBackBtn' color='primaryStrCus'>Back</button>
      <button mat-button color="primaryCus" *ngIf='hasNextBtn' (click)='goFrwd()'>Next</button>
      <button mat-button color="primaryCus" *ngIf='hasSaveBtn' (click)='login()'>Save</button>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="col-12">
    <app-footer></app-footer>
  </div>
</div>